import React, {useEffect, useState} from 'react';
import Pagination from "../../../components/Pagination/Pagination";
import Loading from "../../../rest/Loading";

//https://stackoverflow.com/questions/1714786/query-string-encoding-of-a-javascript-object
const serialize = (obj, prefix) => {
  var str = [], p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
      str.push((v !== null && typeof v === "object") ? serialize(v, k)
        : encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
};


const RetakeResults = ({search_params, download, update, search_params_update, table_config, triggerUpdate}) => {

  const [tableDataRendering, tableDataUpdateRendering] = useState({});
  const [status, statusUpdate] = useState('loading');

  const [currentPage, updateCurrentPage] = useState(search_params.page)
  const [numberOfItems, numberOfItemsUpdate] = useState(0)

  // Define the style of the table
  const tableStyle = "table-auto border-collapse border mt-5 w-full";
  const rowStyleData = "border-b-2 border-secondary-lighter";
  const rowStyleHeader = "bg-secondary-lighter";
  const tableDataStyle = "pr-4";
  const tableHeaderStyle = "";

  function create_file_to_download(data, table_config) {
    data = data.data
    const header = table_config.map((element) => element.Header).join(',')

    const body = data.map((row) => {
      return table_config.map((element) => {
        return (element.hasOwnProperty('transformer')
          ? element.transformer(row[element.accessor])
          : row[element.accessor])
      }).join(',')
    })

    const csv = [header, ...body].join('\n\r')
    const filename = 'retake_data.csv'

    const blob = new Blob([csv], {
      type: 'text/plain;charset=utf-8',
    })

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename)
      return
    }

    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.href = url
    link.download = filename
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  useEffect(() => {
    if (download === 0) {
      return
    }

    const copy = {...search_params};
    delete copy.page;
    delete copy.pageSize;

    const request_url = create_rest_url(copy, false)
    fetch(request_url).then((res) => res.json()).then((data) => create_file_to_download(data, table_config))
  }, [download])


  function filter_parameters(search_params) {
    return Object.fromEntries(
      Object.entries(search_params).filter(([index, value]) => {
        return !(value === "" || value === 'no_filter' || value === null || value === undefined)
      }));
  }

  const create_rest_url = (search_params, push_history = true) => {
    const endpoint = '/rest/v2/report/retake'
    let final_params = filter_parameters(search_params)
    const parms = serialize(final_params)
    const finalUrl = endpoint.concat('?', parms);
    if (push_history) {
      reactHistory.push('/report/retake'.concat('?', parms));
    }
    return finalUrl;
  };

  let render_table = (data) => {
    if (data.hasOwnProperty('data')) {
      numberOfItemsUpdate(data.meta.total_items);
      tableDataUpdateRendering(data.data);
    }
  };

  useEffect(() => {
    const url = create_rest_url(search_params);
    statusUpdate('loading')
    fetch(url).then((res) => res.json()).then(
      (result) => {
        render_table(result);
        statusUpdate('done')
      }).catch(
      (reason => statusUpdate("error")));
  }, [update]);


  useEffect(() => {
    search_params_update({...search_params, 'page': currentPage})
    triggerUpdate(update + 1)
  }, [currentPage])

  const renderTable = (data, setup) => {
    if (Array.isArray(data)) {
      return <table className={tableStyle} key={Math.random()}>
        <thead key={Math.random()}>{tableRowHeader(setup)}</thead>
        <tbody key={Math.random()}>{data.map(
          (row, index) => tableRowData(row, setup, index))}</tbody>
      </table>;
    }
  };

  const tableRowData = (row, setup, index) => {
    const data = setup.map((el) => <td className={tableDataStyle}
                                       key={"table-key-" + index + "-"
                                         + el.Header}>{el.hasOwnProperty(
      'transformer') ? el.transformer(row[el.accessor])
      : row[el.accessor]} </td>);
    return <tr onClick={() => {
      window.open('/order/' + row.orderid, '_blank');
    }}
               className={rowStyleData} key={"table-row-" + index}>{data}</tr>
  }

  const tableRowHeader = (nr2) => {
    const data = nr2.map((el) => <th className={tableHeaderStyle}
                                     key={"table-key-"
                                       + el.Header}>{el.Header}</th>);
    return <tr className={rowStyleHeader} key="table-header">{data}</tr>;
  }

  const render_body = (status, tableDataRendering, table_config) => {
    if (status === 'error') {
      return <div>Error loading....</div>
    } else if (status === 'loading') {
      return <Loading/>
    } else {
      return renderTable(tableDataRendering, table_config);
    }
  }

  return (
    <div className="mx-2">
      {render_body(status, tableDataRendering, table_config)}
      <Pagination updatePageCount={updateCurrentPage}
                  pageCount={search_params.page}
                  showPerPage={search_params.pageSize}
                  totalNumberOfItems={numberOfItems}/>
    </div>)
}

export default RetakeResults;
